
import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleAllowCameraUnderTerrain, toggleDepthTestAgainstTerrain} from "@/modules/cesium/cesium";

const template = document.createElement('template');
template.innerHTML =
`<label class="switcher mr-1">
    <input type="checkbox" class="switcher-input">
    <span class="switcher-indicator">
      <span class="switcher-yes">
        <span class="fa fa-draw-polygon"></span>
      </span>
      <span class="switcher-no">
        <span class="fa fa-times"></span>
      </span>
    </span>
    <span class="switcher-label">Kijk door bodem</span>
  </label>`

export class CesiumToggleDepthButtonComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', (e) => {
            if(e.target.type === 'checkbox') {
                toggleDepthTestAgainstTerrain(!this.querySelector('input').checked)
            }
        });
    }
}

